export default "__VITE_ASSET__BGLZUi_3__"